import angular from 'angular';

import CalendarHeaderModule from './calendar-header';
import CalendarSideBarModule from './calendar-side-bar';
import CalendarDayModule from './calendar-day';
import CalendarDashboardModule from './calendar-dashboard';
import CalendarNavigationModule from './calendar-navigation';

export default angular
    .module('application.scene.authorized.scene.calendar.component', [
        CalendarHeaderModule.name,
        CalendarSideBarModule.name,
        CalendarDayModule.name,
        CalendarDashboardModule.name,
        CalendarNavigationModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/index.js